
import { Injectable } from '@angular/core';
import { ResourceType } from '@core/enums/resource.enum';
import { BusLookup } from '@core/model/bus-lookup/bus-lookup';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedParamsService {
  siteSearch = '';
  facilitySearch = '';
  areaSearch = '';
  prioritySearch = '';
  ProblemSearch = '';
  startDateSearch: string ;
  endDateSearch: string;
  startEntryDateSearch: string ;
  endEntryDateSearch: string;
  ticketNoSearch:string;
  ticketViewType: number;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  weeklyDateRange: any;
  statusSearch: string []= [];
  isClearStatusFilters = false;
  userSearch="";
  calenderType:string
  isComponentLoaded = false;
  sortBy: string;
  orderBy: string
  statusList: BusLookup[]=[];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
  private functionCallSource = new Subject<any>();
  ticketSelectedViewType = 0;
  private selectedColumnsSubject = new BehaviorSubject<{
    progressColumn: string[],
    scheduledColumn: string[]
  }>({
    progressColumn: [],
    scheduledColumn: []
  });

  private prevSubject = new Subject<void>();
  prevRequested$ = this.prevSubject.asObservable();


  private calenderTab=new Subject<string>();
  refreshCalendertab$=this.calenderTab.asObservable();

  private monthValueSubject = new BehaviorSubject<string>('');
  calendarValue$= this.monthValueSubject.asObservable();


  private currentSubject = new Subject<void>();
  currentRequested$ = this.currentSubject.asObservable();

  private nextSubject = new Subject<void>();
  nextRequested$ = this.nextSubject.asObservable();

  private searchUserValueSubject = new BehaviorSubject<string>('');
  searchUserValue$ = this.searchUserValueSubject.asObservable();

  private searchLocationValueSubject = new BehaviorSubject<string>('');
  searchLocationValue$ = this.searchLocationValueSubject.asObservable();

  private userResouceFilterSubject = new BehaviorSubject<ResourceType>(ResourceType.ALL);
  userResourceValue = this.userResouceFilterSubject.asObservable();


  selectedColumns$ = this.selectedColumnsSubject.asObservable();

  // Observable that components can subscribe to
  functionCalled$ = this.functionCallSource.asObservable();

  // Method to call the function in the second component
  //eslint-disable-next-line
  callFunctionInSecondComponent(data: any) {
    this.functionCallSource.next(data);
  }

  constructor() {
    //Empty constructor
  }

  ticketFilters(

      ){
      const filters = {

      params: {
        facilitySearch : this.facilitySearch,
         siteSearch : this.siteSearch,
         areaSearch : this.areaSearch,
        prioritySearch : this.prioritySearch,
        ProblemSearch : this.ProblemSearch,
        statusSearch : this.statusSearch,
        userSearch:this.userSearch,
        startDateSearch : this.startDateSearch,
        endDateSearch : this.endDateSearch,
        startEntryDateSearch : this.startEntryDateSearch,
        endEntryDateSearch : this.endEntryDateSearch,
        ticketNoSearch : this.ticketNoSearch,
        ticketViewType : this.ticketViewType,
        calenderType: this.calenderType,
        orderBy: this.orderBy,
        sortBy:this.sortBy
       }
    };
    return filters;

    }


  setSelectedColumns(column1: string[], column2: string[]) {
    this.selectedColumnsSubject.next({
      progressColumn: column1,
      scheduledColumn: column2
    });
  }

  setUserSearchValue(value: string) {
    this.searchUserValueSubject.next(value);
  }

  setUserResourceValue(value: ResourceType) {
    this.userResouceFilterSubject.next(value);
  }

  setLocationAreaSearchValue(value: string) {
    this.searchLocationValueSubject.next(value);
  }

  requestPrev() {
    this.prevSubject.next();
  }

  requestNext() {
    this.nextSubject.next();
  }

  requestCurrent() {
    this.currentSubject.next();
  }


  // Update the string value
  updateCalendarValue(value: string) {
    this.monthValueSubject.next(value);
  }

  // Get current string value
  getCurrentValue(): string {
    return this.monthValueSubject.value;
  }

  updateCalendertab(){
    this.calenderTab.next(this.calenderType);
  }

}
